import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const maskIconFn = /* @__PURE__ */ createRecipe('mask-icon-v2', {
  "size": "sm"
}, [])

const maskIconVariantMap = {
  "glyph": [
    "expand-more",
    "expand-less",
    "help-outline",
    "open-in-new",
    "checkbox-outlined",
    "credit-card",
    "list-filled",
    "nw",
    "bookmark-outline",
    "bullet-plus",
    "bullet-minus",
    "check-circle",
    "close",
    "check",
    "checkbox-check",
    "checkbox-blank",
    "chevron-right",
    "home",
    "pushpin",
    "vertical-align-top",
    "verified",
    "keyboard-arrow-down",
    "keyboard-arrow-up",
    "keyboard-arrow-left",
    "keyboard-arrow-right",
    "add",
    "add-circle",
    "remove",
    "cancel",
    "tune",
    "arrow-drop-down",
    "arrow-forward",
    "search",
    "loop",
    "access-alarm",
    "list-alt",
    "payment",
    "diamond-outlined",
    "manage-search",
    "psychology",
    "balance",
    "thumbs-up-down-outlined",
    "thumb-down-outlined",
    "thumb-up-outlined",
    "favorite-border",
    "percent-outlined",
    "verified-outlined",
    "discount-outlined",
    "trending-up-outlined",
    "socials-email",
    "socials-facebook",
    "socials-linkedin",
    "socials-x"
  ],
  "size": [
    "sm",
    "md",
    "lg",
    "xl",
    "xxl"
  ]
}

const maskIconVariantKeys = Object.keys(maskIconVariantMap)

export const maskIcon = /* @__PURE__ */ Object.assign(memo(maskIconFn.recipeFn), {
  __recipe__: true,
  __name__: 'maskIcon',
  __getCompoundVariantCss__: maskIconFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: maskIconVariantKeys,
  variantMap: maskIconVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, maskIconVariantKeys)
  },
  getVariantProps: maskIconFn.getVariantProps,
})